import { Directive } from '@angular/core';

@Directive({
  selector: '[pleInsertion]'
})
export class InsertionDirective {

  constructor() { }

}
